import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import type { MemberOrders } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberOrders.AppState>(defaultState, previewState);
